<template>
    <DsModal
        data-qa="modal-title"
        is-open
        size="sm"
        show-close
        :title="$t('funnel.edit.sequence.rename.title')"
        @close="closeEditSequenceNameModal"
    >
        <template #header>
            <DsFilledButton
                data-qa="save-button"
                @click="handleSave"
            >
                {{ $t('funnel.edit.save') }}
            </DsFilledButton>
        </template>
        <template #default>
            <DsInputField
                v-model="newSequenceName"
                :label="$t('funnel.edit.sequence.rename.input.label')"
                data-qa="funnel-name"
            />
        </template>
    </DsModal>
</template>

<script>

export default {
    props: {
        sequenceCell: {
            type: Object,
            required: true,
        },
        isSpaApp: {
            type: Boolean,
            default: false,
        },
        funnelId: {
            type: Number,
            default: 0,
        },
    },
    emits: ['update-name', 'close-modal'],

    data() {
        return {
            newSequenceName: '',
        };
    },

    mounted() {
        this.newSequenceName = this.sequenceCell?.value?.name || this.sequenceCell.value.name;
    },

    methods: {
        handleSave() {
            const { newSequenceName } = this;

            this.$emit('update-name', { newSequenceName });
            this.closeEditSequenceNameModal();
        },

        closeEditSequenceNameModal() {
            this.$emit('close-modal');
        },
    },
};

</script>
